// Converts a workflow-execution SSE event into a single human-readable log
// line for the live Run Log panel. Pure + dependency-free so it's trivial to
// reuse and test. Returns null for events we don't surface in the log strip.
//
// Each returned line has: { tone, text }
//   tone: 'info' | 'success' | 'error' | 'muted'  (drives the dot color)
//   text: the message shown to the user

// Resolve a node's display title from the current workflow nodes. Falls back
// to the raw id so a line is never blank.
function nodeTitle(nodes, nodeId) {
  if (!nodeId) return '';
  var list = Array.isArray(nodes) ? nodes : [];
  for (var i = 0; i < list.length; i++) {
    var n = list[i];
    if (n && String(n.id) === String(nodeId)) {
      return String(n.title || n.id || '').trim() || String(nodeId);
    }
  }
  return String(nodeId);
}

// Format a duration in ms as a short "12.5s" / "850ms" style string.
function shortDuration(ms) {
  if (ms == null || isNaN(ms)) return '';
  if (ms < 1000) return Math.round(ms) + 'ms';
  return (ms / 1000).toFixed(1) + 's';
}

// Pull a duration (ms) off whichever field the event carries it in.
function pickDuration(event) {
  if (!event) return null;
  if (event.durationMs != null) return event.durationMs;
  if (event.timing && event.timing.durationMs != null) return event.timing.durationMs;
  return null;
}

// Build a log line from one SSE event. `nodes` is the current workflow node
// list (for title lookup). Returns null when the event isn't worth a line.
function runLogLineFromEvent(event, nodes) {
  if (!event || !event.type) return null;
  var type = event.type;
  var title = nodeTitle(nodes, event.nodeId);
  var line;

  switch (type) {
    case 'execution.started':
      line = { tone: 'info', text: 'Run started' };
      break;
    case 'node.started':
      line = { tone: 'info', text: title + ' started' };
      break;
    case 'node.completed': {
      var durMs = pickDuration(event);
      var dur = durMs != null ? ' (' + shortDuration(durMs) + ')' : '';
      line = {
        tone: 'success',
        text: '✓ ' + title + ' completed' + dur,
        durationMs: durMs,
        input: event.input,
        output: event.output
      };
      break;
    }
    case 'node.failed':
      line = {
        tone: 'error',
        text: '✕ ' + title + ' failed' + (event.error ? ': ' + String(event.error) : ''),
        durationMs: pickDuration(event),
        input: event.input,
        output: event.error ? { error: String(event.error) } : event.output
      };
      break;
    case 'node.skipped':
      line = { tone: 'muted', text: title + ' skipped' };
      break;
    case 'execution.completed':
      line = { tone: 'success', text: '✓ Run completed' };
      break;
    case 'execution.failed':
      line = { tone: 'error', text: '✕ Run failed' + (event.error ? ': ' + String(event.error) : '') };
      break;
    case 'execution.stopped':
      line = { tone: 'muted', text: 'Run stopped' };
      break;
    case 'execution.paused':
      line = { tone: 'muted', text: 'Run paused' };
      break;
    case 'execution.resumed':
      line = { tone: 'info', text: 'Run resumed' };
      break;
    default:
      return null;
  }

  // Carry the node id (when present) so the panel can focus the canvas on the
  // matching node when a line is hovered.
  if (line && event.nodeId) line.nodeId = String(event.nodeId);
  return line;
}

module.exports = {
  runLogLineFromEvent: runLogLineFromEvent,
  shortDuration: shortDuration
};
